import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Credit from "./styled/credit";

const Audio = ({ src, vtts = [], credit = undefined, image = undefined, caption = undefined }) => {

  const videoRef = useRef(null);

  const [currentCue, setCurrentCue] = useState('');
  const [isPlaying, setIsPlaying] = useState(false);
  const [isActive, setIsActive] = useState(false)

  function handleCueChange(e) {
    if ( this?.activeCues[0]?.text ) {
      setCurrentCue(this.activeCues[0].text);
    }
    else {
      setCurrentCue('');
    }
  }

  function handleTogglePlay() {
    if ( isPlaying ) {
      videoRef.current.pause();
    }
    else {
      videoRef.current.play();
      setIsActive(true);
    }
  }

  useEffect(() => {
    if ( ! videoRef.current )
      return;

    const video = videoRef.current;
    const track = video.textTracks[0];
    track.mode = "hidden";
    track.oncuechange = handleCueChange;
    
  }, []);

  return (
    <StyledAudioPlayer
      className={isActive ? 'is-active' : undefined}
    >
      <div>
        <video 
          playsInline="playsinline"
          ref={videoRef}
          onClick={(e) => e.target.play()}
          onPlaying={() => { setIsPlaying(true); setIsActive(true);}}
          onPause={() => setIsPlaying(false)}
        >
          <source type="audio/mp3" src={src} />
          {vtts.map((vtt, index) => (
            <track key={`vtt-${index}`} default src={vtt} />
          ))}
        </video>
        <StyledLabel>Voice Message</StyledLabel>
        <StyledButton onClick={handleTogglePlay} className={isPlaying ? 'is-playing' : undefined}>
          {isPlaying ? (
            <Pause />
          ) : (
            <Play />
          )}
        </StyledButton>
        <StyledMeta>
          <span>{caption ? caption : `Aliou Candé calls his brothers from Al Mabani asking for help`}</span>
          <time>March 30, 2021</time>
        </StyledMeta>
        {image && (
          <StyledPhoto>{image}</StyledPhoto>
        )}
        <StyledCaption>
          <span>{currentCue}</span>
        </StyledCaption>
      </div>
      {credit && (
        <Credit>{credit}</Credit>
      )}
    </StyledAudioPlayer>
  )
}
export default Audio

const StyledAudioPlayer = styled.figure`
  position: relative;
  margin: calc(2.5 * var(--text-size)) auto;
  max-width: var(--text-max-width);
  > div {
    position: relative;
    display: grid;
    grid-template: 1fr / 2em 1fr;
    grid-gap: 1.25em;
    align-items: center;
    padding: calc(2 * var(--text-size)) 0 calc(2 * var(--text-size));
    border: solid var(--theme-border-against-light);
    border-width: 1px 0;
    font-family: var(--font-sans);
  }
  video {
    object-fit: initial;
    height: 0;
    width: 0;
    position: fixed;
    display: block;
    left: -999em;
  }
`

const StyledLabel = styled.div`
  position: absolute;
  top: 0;
  font-size: 0.75em;
  font-family: var(--font-caption);
  font-weight: var(--font-caption-weight);
  text-transform: uppercase;
  background-color: #ccc;
  padding: 0.25em 0.5em;
  line-height: 1;
  color: var(--theme-text-against-dark-medium);
  display: none;
`
const StyledPhoto = styled.figure`
  position: absolute;
  top: 50%;
  transform: translate3d(0,-50%,0);
  width: 100%;
  right: calc(100% + 1.75em);
  max-width: 10em;

`

const StyledButton = styled.button`
  display: flex;
  padding: 0;
  svg {
    height: 2em;
    width: 2em;
    path {
      fill: currentColor;
    }
  }
  i {
    position: relative;
    display: block;
    height: 1em;
    width: 0.75em;
    margin-top: 0.0625em;
    margin-left: 0.125em;
    background-color: currentColor;
    clip-path: polygon(0 0, 100% 50%, 0 100%);
  }
  &.is-playing i {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    margin-left: 0;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      width: 0.2em;
      background-color: var(--theme-background-light);
      margin-left: -0.1em;
    }
  }
`
const StyledMeta = styled.div`
  grid-row: 1;
  grid-column: 2;
  transition: transform 0.2s ease, opacity 0.2s ease;
  transform-origin: left center;
  transform: translate3d(0,0,0) scale(1);
  ${StyledAudioPlayer}.is-active & {
    transform: translate3d(0,calc(100% - 0.25em),0) scale(0.7);
  }
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  span {
    font-size: 1.125em;
  }
  time {
    font-family: var(--font-caption);
    font-weight: var(--font-caption-weight);
    color: var(--theme-text-against-dark-medium);
  }
`
const StyledCaption = styled.div`
  grid-row: 1;
  grid-column: 2;
  span {
    font-size: 1.125em;
  }
`
/* <audio controls="controls" src="/chapter-three/There is no guarantee.mp3" /> */


const Play = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.22 32.22"><path d="M11.94,24V8.24l11.32,7.87Zm20.28-7.87A16.11,16.11,0,1,1,16.11,0,16.12,16.12,0,0,1,32.22,16.11Zm-1,0A15.09,15.09,0,1,0,16.11,31.2,15.11,15.11,0,0,0,31.2,16.11Z"/></svg>
);

const Pause = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.22 32.22"><path d="M16.11,0A16.11,16.11,0,1,0,32.22,16.11,16.13,16.13,0,0,0,16.11,0Zm0,31.2A15.09,15.09,0,1,1,31.2,16.11,15.11,15.11,0,0,1,16.11,31.2Zm-2-8.41H10.84V9.43h3.27Zm7.27,0H18.12V9.43h3.26Z"/></svg>
)